'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector('#tree');
function createTree(element, data) {
    // WRITE YOUR CODE HERE
    var ul = document.createElement('ul');
    for(var key in data)if (Object.prototype.hasOwnProperty.call(data, key)) {
        var li = document.createElement('li');
        li.textContent = key;
        var value = data[key];
        if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === 'object' && value !== null && Object.keys(value).length > 0) createTree(li, value);
        ul.append(li);
    }
    element.append(ul);
}
createTree(tree, food);

//# sourceMappingURL=js_tree-from-object-DOM.39fc6d7c.js.map
